import React from "react";
import AuthService from "./AuthService";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./Home";
import Dashboard from "./Dashboard";
import PrivateRoute from "./PrivateRoute";
import PrivateLayout from "./PrivateLayout";
import Settings from "./Settings/Settings";
import Students from "./Students/Students";
import Teachers from "./Teachers/Teachers";
import Parents from "./Parents/Parents";
import HeadmasterOffice from "./Headmaster/HeadmasterOffice";
import HeadOfficeDashboard from "./Headmaster/HeadOfficeDashboard";
import DeputyHeadDashboard from "./Headmaster/DeputyHeadDashboard";
import FeesBilling from "./Finance/FeesBilling";
import ExamsResults from "./Results/ExamsResults";
import Elearning from "./Elearning/Elearning";
import ICTRobotics from "./ICTRobotics/ICTRobotics";
import Library from "./Library/Library";
import Discipline from "./Discipline/Discipline";
import EventsSports from "./EventsSports/EventsSports";
import HousesPage from "./EventsSports/HousesPage";
import MyProfilePage from "./MyProfilePage";
import StudentTimetablePage from "./StudentPortal/StudentTimetablePage";
import StudentLearningPage from "./StudentPortal/StudentLearningPage";
import StudentResultsPage from "./StudentPortal/StudentResultsPage";
import StudentReportCardPage from "./StudentPortal/StudentReportCardPage";
import StudentFinancePage from "./StudentPortal/StudentFinancePage";
import StudentLibraryPage from "./StudentPortal/StudentLibraryPage";
import StudentICTRoboticsPage from "./StudentPortal/StudentICTRoboticsPage";
import StudentEventsSportsPage from "./StudentPortal/StudentEventsSportsPage";
import StudentConductPage from "./StudentPortal/StudentConductPage";
import StudentProfilePage from "./StudentPortal/StudentProfilePage";
import TeacherTimetablePage from "./TeacherPortal/TeacherTimetablePage";
import TeacherClassesPage from "./TeacherPortal/TeacherClassesPage";
import TeacherStudentsPage from "./TeacherPortal/TeacherStudentsPage";
import TeacherSubjectsPage from "./TeacherPortal/TeacherSubjectsPage";
import TeacherMarksPage from "./TeacherPortal/TeacherMarksPage";
import TeacherLearningPage from "./TeacherPortal/TeacherLearningPage";
import TeacherLiveClassesPage from "./TeacherPortal/TeacherLiveClassesPage";
import TeacherConductPage from "./TeacherPortal/TeacherConductPage";
import TeacherICTRoboticsPage from "./TeacherPortal/TeacherICTRoboticsPage";
import TeacherLibraryPage from "./TeacherPortal/TeacherLibraryPage";
import TeacherEventsSportsPage from "./TeacherPortal/TeacherEventsSportsPage";
import TeacherProfilePage from "./TeacherPortal/TeacherProfilePage";
import ParentChildrenPage from "./ParentPortal/ParentChildrenPage";
import ParentChildDashboardPage from "./ParentPortal/ParentChildDashboardPage";
import ParentChildProfilePage from "./ParentPortal/ParentChildProfilePage";
import ParentChildTimetablePage from "./ParentPortal/ParentChildTimetablePage";
import ParentChildLearningPage from "./ParentPortal/ParentChildLearningPage";
import ParentChildResultsPage from "./ParentPortal/ParentChildResultsPage";
import ParentChildReportCardPage from "./ParentPortal/ParentChildReportCardPage";
import ParentChildFinancePage from "./ParentPortal/ParentChildFinancePage";
import ParentChildLibraryPage from "./ParentPortal/ParentChildLibraryPage";
import ParentChildICTRoboticsPage from "./ParentPortal/ParentChildICTRoboticsPage";
import ParentChildEventsSportsPage from "./ParentPortal/ParentChildEventsSportsPage";
import ParentChildConductPage from "./ParentPortal/ParentChildConductPage";
import ParentProfilePage from "./ParentPortal/ParentProfilePage";
import ParentReportsPage from "./ParentPortal/ParentReportsPage";
import TeacherParentReportsPage from "./TeacherPortal/TeacherParentReportsPage";
import SchoolAIPage from "./AI/SchoolAIPage";
import SchoolCommunicationsPage from "./Communications/SchoolCommunicationsPage";
import TeacherClassNoticesPage from "./TeacherPortal/TeacherClassNoticesPage";
import StudentClassNoticesPage from "./StudentPortal/StudentClassNoticesPage";
import ParentClassNoticesPage from "./ParentPortal/ParentClassNoticesPage";

function RoleDashboard() {
  const user = AuthService.getCurrentUser();
  if (user?.user_type === "DEPUTY_HEAD") {
    return <DeputyHeadDashboard />;
  }
  return <Dashboard />;
}

function Main() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      <Route element={<PrivateRoute />}>
        <Route element={<PrivateLayout />}>
          <Route path="/dashboard" element={<RoleDashboard />} />
          <Route
            path="/headmaster"
            element={
              <HeadmasterOffice
                officeLabel="The Head's Office"
                officeContext="HEAD"
              />
            }
          />
          <Route path="/deputy-head" element={<DeputyHeadDashboard />} />
          <Route
            path="/deputy-head/communications"
            element={
              <HeadmasterOffice
                officeLabel="Deputy Head's Office"
                officeContext="DEPUTY"
              />
            }
          />
          <Route
            path="/settings"
            element={
              ["ADMIN", "SUPER_ADMIN"].includes(
                AuthService.getCurrentUser()?.user_type
              ) ? (
                <Settings />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            }
          />
          <Route path="/students" element={<Students />} />
          <Route path="/teachers" element={<Teachers />} />
          <Route path="/parents" element={<Parents />} />
          <Route path="/finance" element={<FeesBilling />} />
          <Route path="/results" element={<ExamsResults />} />
          <Route path="/elearning" element={<Elearning />} />
          <Route path="/ict-robotics" element={<ICTRobotics />} />
          <Route path="/library" element={<Library />} />
          <Route path="/discipline" element={<Discipline />} />
          <Route path="/events" element={<EventsSports />} />
          <Route path="/houses" element={<HousesPage />} />
          <Route path="/profile" element={<MyProfilePage />} />
          <Route path="/student/timetable" element={<StudentTimetablePage />} />
          <Route path="/student/learning" element={<StudentLearningPage />} />
          <Route path="/student/results" element={<StudentResultsPage />} />
          <Route path="/student/results/report/:sessionId" element={<StudentReportCardPage />} />
          <Route path="/student/finance" element={<StudentFinancePage />} />
          <Route path="/student/library" element={<StudentLibraryPage />} />
          <Route path="/student/ict-robotics" element={<StudentICTRoboticsPage />} />
          <Route path="/student/events-sports" element={<StudentEventsSportsPage />} />
          <Route path="/student/conduct" element={<StudentConductPage />} />
          <Route path="/student/profile" element={<StudentProfilePage />} />
          <Route path="/student/communications" element={<SchoolCommunicationsPage />} />
          <Route path="/student/class-notices" element={<StudentClassNoticesPage />} />
          <Route path="/student/ai-assistant" element={<SchoolAIPage />} />
          <Route path="/teacher/timetable" element={<TeacherTimetablePage />} />
          <Route path="/teacher/classes" element={<TeacherClassesPage />} />
          <Route path="/teacher/students" element={<TeacherStudentsPage />} />
          <Route path="/teacher/subjects" element={<TeacherSubjectsPage />} />
          <Route path="/teacher/marks" element={<TeacherMarksPage />} />
          <Route path="/teacher/learning" element={<TeacherLearningPage />} />
          <Route path="/teacher/live-classes" element={<TeacherLiveClassesPage />} />
          <Route path="/teacher/conduct" element={<TeacherConductPage />} />
          <Route path="/teacher/ict-robotics" element={<TeacherICTRoboticsPage />} />
          <Route path="/teacher/library" element={<TeacherLibraryPage />} />
          <Route path="/teacher/events-sports" element={<TeacherEventsSportsPage />} />
          <Route path="/teacher/profile" element={<TeacherProfilePage />} />
          <Route path="/teacher/parent-reports" element={<TeacherParentReportsPage />} />
          <Route path="/teacher/communications" element={<SchoolCommunicationsPage />} />
          <Route path="/teacher/class-notices" element={<TeacherClassNoticesPage />} />
          <Route path="/teacher/ai-assistant" element={<SchoolAIPage />} />
          <Route path="/parent/children" element={<ParentChildrenPage />} />
          <Route path="/parent/children/:studentId" element={<ParentChildDashboardPage />} />
          <Route path="/parent/children/:studentId/profile" element={<ParentChildProfilePage />} />
          <Route path="/parent/children/:studentId/timetable" element={<ParentChildTimetablePage />} />
          <Route path="/parent/children/:studentId/learning" element={<ParentChildLearningPage />} />
          <Route path="/parent/children/:studentId/results" element={<ParentChildResultsPage />} />
          <Route path="/parent/children/:studentId/results/report/:sessionId" element={<ParentChildReportCardPage />} />
          <Route path="/parent/children/:studentId/finance" element={<ParentChildFinancePage />} />
          <Route path="/parent/children/:studentId/library" element={<ParentChildLibraryPage />} />
          <Route path="/parent/children/:studentId/ict-robotics" element={<ParentChildICTRoboticsPage />} />
          <Route path="/parent/children/:studentId/events-sports" element={<ParentChildEventsSportsPage />} />
          <Route path="/parent/children/:studentId/conduct" element={<ParentChildConductPage />} />
          <Route path="/parent/announcements" element={<SchoolCommunicationsPage />} />
          <Route path="/parent/class-notices" element={<ParentClassNoticesPage />} />
          <Route path="/parent/profile" element={<ParentProfilePage />} />
          <Route path="/parent/reports" element={<ParentReportsPage />} />
          <Route path="/parent/ai-assistant" element={<SchoolAIPage />} />
          <Route path="/ai-assistant" element={<SchoolAIPage />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default Main;
